import axios from 'axios';

// URL base dell'API per le fasi, recuperato dall'env file
const FASI_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'bilancio-partecipativo-fasi';

// Definizione dell'header per le richieste con JSON
const headers = { 'Content-Type': 'application/json' };

class BilancioPartecipativoFasiService {


    /**
     * Aggiorna le fasi del bilancio partecipativo.
     * Effettua una richiesta POST a `/bilancio-partecipativo-fasi/save` inviando i dati aggiornati.
     *
     * @param {Object} bilancio - Oggetto contenente le informazioni sulle fasi del bilancio.
     * @returns {Promise} - Una promessa che restituisce la risposta del server.
     */
    aggiornaFasi(bilancio) {
        return axios.post(FASI_REST_API_URL + "/save", bilancio, { headers });
    }

     /**
     * Elimina le fasi specifiche che vengono passate.
     * Effettua una richiesta POST a `/bilancio-partecipativo-fasi/delete` con un array di oggetti da eliminare.
     *
     * @param {Array<Object>} fasi - Lista delle fasi da eliminare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server.
    */
    eliminaFasi(fasi) {
        return axios.post(FASI_REST_API_URL + "/delete", fasi, { headers });
    }
}
// Creazione dell'istanza per essere importata direttamente nei componenti
const bilancioPartecipativoFasiServiceInstance = new BilancioPartecipativoFasiService();
export default bilancioPartecipativoFasiServiceInstance;
